<form *ngIf="!isLoading">
    <label class="toggle-switch clearfix" *ngIf="showSettings.createLayerForEachGraphic">
        <span class="togggle-switch-label left font-size--1">Create a seperate layer for each graphic</span>&nbsp;
        <input type="checkbox" name="seperate" class="toggle-switch-input" [(ngModel)]="createLayerForEachGraphic">
        <span class="toggle-switch-track right"></span>
    </label>

    <div class="setting" *ngIf="showSettings.mode">
        <label for="mode">Mode</label>
        <select id="mode" class="select-full" name="mode" [(ngModel)]="selectedPolylineMode" (ngModelChange)="reset()">
            <option *ngFor="let option of polylineModes" [ngValue]="option" [title]="option.description" [disabled]="option.disabled">{{ option.name }}</option>
        </select>
    </div>

    <div class="setting" *ngIf="showSettings.style">
        <label for="style">Line Style</label>
        <select id="style" name="style" [(ngModel)]="symbolProperties.style">
            <option *ngFor="let option of lineStyleOptions" [value]="option.value">{{ option.name }}</option>
        </select>
    </div>

    <div *ngIf="!isLineStyleSupportedForPrinting" class="alert alert-yellow is-active info-div">
        <b>Warning:</b> This line style is not supported for printing, and will be replaced with {{ replacementLineStyle }} in the printed map.
    </div>

    <div class="setting" *ngIf="showSettings.width">
        <label for="width">Line Width</label>
        <input id="width" type="number" name="width" [(ngModel)]="symbolProperties.width" required>
    </div>

    <div class="setting" *ngIf="showSettings.color">
        <label for="color" (click)="colorPicker.showColorPicker = true;">Line Color</label>
        <mc-color-picker-ng #colorPicker [(color)]="symbolProperties.color"></mc-color-picker-ng>
    </div>

    <div class="setting" *ngIf="showSettings.unit">
        <label for="unit">Length Unit</label>
        <select id="unit" name="unit" [(ngModel)]="selectedLengthUnit">
            <option *ngFor="let option of lengthUnits" [ngValue]="option" [title]="option.description">{{ option.name }}</option>
        </select>
    </div>
</form>
<div *ngIf="isLoading" class="loader is-active padding-leader-3 padding-trailer-3">
    <div class="loader-bars"></div>
</div>